<template>
  <div class="px-12 h-auto">
    <!-- Header -->
    <header class="bg-white border-b border-gray-200 shadow-sm">
      <div class="mx-auto px-4 py-3 flex justify-between items-center">
        <h1 class="text-2xl font-bold text-blue-900">E-Learning Management</h1>
        <div class="flex items-center">
          <div class="relative mr-3">
            <span
              class="absolute top-0 right-0 -mt-1 -mr-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">3</span>
            <button class="text-gray-500">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 01-6 0v-1m6 0H9" />
              </svg>
            </button>
          </div>
          <div class="flex items-center">
            <button @click="dropdownOpen = !dropdownOpen"
              class="relative flex items-center w-18 h-12 overflow-hidden focus:outline-none">
              <img src="@/assets/images/avatar.png" alt="profile" class="w-10 h-10 rounded-full object-cover mr-2" />
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div v-show="dropdownOpen" @click="dropdownOpen = false" class="fixed inset-0 z-10 w-full h-full"></div>
            <transition enter-active-class="transition duration-150 ease-out transform"
              enter-from-class="scale-95 opacity-0" enter-to-class="scale-100 opacity-100"
              leave-active-class="transition duration-150 ease-in transform" leave-from-class="scale-100 opacity-100"
              leave-to-class="scale-95 opacity-0">
              <div v-show="dropdownOpen" class="absolute right-0 z-20 w-48 py-2 mt-40 bg-white rounded-md shadow-xl">
                <button href="#"
                  class="block px-4 py-2 text-sm w-full text-gray-700 hover:bg-blue-600 hover:text-orange-400"
                  @click="redirectProfilePage">Profile</button>
                <button class="block px-4 py-2 w-full text-sm text-gray-700 hover:bg-blue-600 hover:text-orange-400"
                  @click="logout">
                  Log out
                </button>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <div v-if="currentTab === 'institutions'">
      <div class="flex justify-between my-6">
        <div class="relative w-64">
          <input type="text" v-model="searchQuery" placeholder="Search"
            class="w-full pl-3 pr-10 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-transparent" />
          <button class="absolute right-0 top-0 h-full px-3 text-white bg-orange-400 rounded-r">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>
        </div>
        <button type="button"
          class="flex items-center px-4 py-2 bg-orange-400 text-white rounded hover:bg-orange-300 transition"
          @click="openNewInstitutionModalForm">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          Register Institution
        </button>
      </div>

      <!-- Stats Cards -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div class="bg-white p-6 rounded shadow">
          <h3 class="text-gray-500 font-medium mb-1">Total Institutions</h3>
          <p class="text-3xl font-bold">{{ statistics.total_institutions || 0 }}</p>
        </div>
        <div class="bg-white p-6 rounded shadow">
          <h3 class="text-gray-500 font-medium mb-1">Active Institutions</h3>
          <p class="text-3xl font-bold">{{ statistics.total_active_institutions || 0 }}</p>
        </div>
        <div class="bg-white p-6 rounded shadow">
          <h3 class="text-gray-500 font-medium mb-1">Suspended Institutions</h3>
          <p class="text-3xl font-bold">{{ statistics.total_suspended_institutions || 0 }}</p>
        </div>
      </div>
    </div>

    <!-- Locums content -->
    <div v-if="currentTab === 'locums'" class="pt-4">
      <div class="flex justify-end gap-4 py-5">
        <div class="relative w-64">
          <input type="text" v-model="searchQuery" placeholder="Search"
            class="w-full pl-3 pr-10 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-transparent" />
          <button class="absolute right-0 top-0 h-full px-3 text-white bg-orange-400 rounded-r">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Income cards -->
    <div v-if="currentTab === 'total-income'" class="pt-4">
      <!-- Date and Search Inputs -->
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-4 py-5">
        <!-- Date Picker -->
        <div class="relative w-full sm:w-48">
          <input type="date"
            class="border border-gray-300 rounded-md px-4 py-2 w-full text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition duration-200"
            value="2025-08-17" />
        </div>

        <!-- Search Bar -->
        <div class="relative w-64">
          <input type="text" v-model="searchQuery" placeholder="Search"
            class="w-full pl-3 pr-10 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-transparent" />
          <button class="absolute right-0 top-0 h-full px-3 text-white bg-orange-400 rounded-r">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Overview Section -->
      <div class="bg-white rounded-xl mb-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <!-- Active Institutions -->
          <div class="bg-white p-6 rounded shadow">
            <p class="text-gray-500 text-lg font-medium mb-2">Active Institutions</p>
            <h2 class="text-3xl font-bold text-gray-800">{{ statistics.total_active_institutions || 0 }}</h2>
          </div>

          <!-- Total Revenue -->
          <div class="bg-white p-6 rounded shadow">
            <p class="text-gray-500 text-lg font-medium mb-2">Total Revenue</p>
            <div class="flex items-center justify-between">
              <h2 class="text-3xl font-bold text-gray-800 mr-3">KES {{ statistics.total_revenue || 0 }}</h2>
              <span class="text-red-600 text-sm font-semibold bg-red-100 px-3 py-1 rounded-full">
                -1.2%
              </span>
            </div>
          </div>

          <!-- Total Disbursed -->
          <div class="bg-white p-6 rounded shadow">
            <p class="text-gray-500 text-lg font-medium mb-2">Total Disbursed</p>
            <div class="flex items-center justify-between">
              <h2 class="text-3xl font-bold text-gray-800 mr-3">KES {{ statistics.total_disbursed || 0 }}</h2>
              <span class="text-green-600 text-sm font-semibold bg-green-100 px-3 py-1 rounded-full">
                +11%
              </span>
            </div>
          </div>

          <!-- Revenue Retained -->
          <div class="bg-white p-6 rounded shadow">
            <p class="text-gray-500 text-lg font-medium mb-2">Revenue Retained</p>
            <div class="flex items-center justify-between">
              <h2 class="text-3xl font-bold text-gray-800 mr-3">KES {{ statistics.total_commission || 0 }}</h2>
              <span class="text-green-600 text-sm font-semibold bg-green-100 px-3 py-1 rounded-full">
                +5.2%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="currentTab === 'institution-income'" class="pt-4">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-5">
        <!-- Left Section with Logo, Name, and Statistic -->
        <div class="flex items-center gap-4">
          <img :src="statistics?.institution?.logo_url || ''" alt="" class="object-cover w-18 h-10"
            @error="onImageError" />
          <h2 class="text-xl font-bold text-gray-800">{{ institutionName }}</h2>
        </div>

        <!-- Right Section with Date and Search -->
        <div class="flex flex-col sm:flex-row sm:items-center gap-4">
          <!-- Date Picker -->
          <div class="relative w-full sm:w-48">
            <input type="date"
              class="border border-gray-300 rounded-md px-4 py-2 w-full text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition duration-200"
              value="2025-08-17" />
          </div>

          <!-- Search Bar -->
          <div class="relative w-64">
            <input type="text" v-model="searchQuery" placeholder="Search"
              class="w-full pl-3 pr-10 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-transparent" />
            <button class="absolute right-0 top-0 h-full px-3 text-white bg-orange-400 rounded-r">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Overview Section -->
      <div class="bg-white rounded-xl mb-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          <!-- All Courses -->
          <div class="bg-white p-6 rounded shadow">
            <p class="text-gray-500 text-lg font-medium mb-2">All Courses</p>
            <h2 class="text-3xl font-bold text-gray-800">{{ statistics.total_active_institutions || 0 }}</h2>
          </div>

          <!-- Paid Enrollments -->
          <div class="bg-white p-6 rounded shadow">
            <p class="text-gray-500 text-lg font-medium mb-2">Paid Enrollments</p>
            <h2 class="text-3xl font-bold text-gray-800">{{ statistics.total_active_institutions || 0 }}</h2>
          </div>

          <!-- Total Revenue -->
          <div class="bg-white p-6 rounded shadow">
            <p class="text-gray-500 text-lg font-medium mb-2">Total Revenue</p>
            <div class="flex items-center justify-between">
              <h2 class="text-3xl font-bold text-gray-800 mr-3">KES {{ statistics.total_revenue || 0 }}</h2>
            </div>
          </div>

          <!-- Pending Payouts -->
          <div class="bg-white p-6 rounded shadow">
            <p class="text-gray-500 text-lg font-medium mb-2">Pending Payouts</p>
            <div class="flex items-center justify-between">
              <h2 class="text-3xl font-bold text-gray-800 mr-3">KES {{ statistics.total_pending_payouts || 0 }}</h2>
            </div>
          </div>

          <!-- Payout Made -->
          <div class="bg-white p-6 rounded shadow">
            <p class="text-gray-500 text-lg font-medium mb-2">Payout Made</p>
            <div class="flex items-center justify-between">
              <h2 class="text-3xl font-bold text-gray-800 mr-3">KES {{ 0 }}</h2>
              <span class="text-green-600 text-sm font-semibold bg-green-100 px-3 py-1 rounded-full">
                +5.2%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Register Institution Modal -->
    <RegisterInstitutionModal :show="showInstitutionModal" @close="closeInstitutionModal"
      @institution-created="handleInstitutionCreated" />

    <!-- Courses Coupon Header Section -->
    <div v-if="currentTab === 'courses-coupon'" class="pt-4">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 py-1">
        <div class="flex items-center">
          <h2 class="text-xl font-bold text-gray-800">Discount Courses Management</h2>
        </div>
      </div>
    </div>

    <!-- Courses Coupon Funding Overview -->
    <div v-if="currentTab === 'courses-coupon'" class="bg-white rounded-xl mb-6">
      <div class="flex justify-between items-center p-4">
        <h3 class="text-lg font-semibold text-gray-800">Funding Overview</h3>
        <button @click="openCouponModal"
          class="flex items-center px-4 py-2 bg-orange-400 text-white rounded hover:bg-orange-300 transition">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          Create Coupon
        </button>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 p-4 pt-0">
        <div class="bg-white p-4 rounded shadow">
          <p class="text-gray-500 text-sm font-medium mb-2">Active Discounts</p>
          <h2 class="text-2xl font-bold text-gray-800">{{ statistics?.active_discounts || 0 }}</h2>
          <p class="text-xs text-gray-400 mt-1">Total active coupon campaigns</p>
        </div>
        <div class="bg-white p-4 rounded shadow">
          <p class="text-gray-500 text-sm font-medium mb-2">Total Used Coupons</p>
          <h2 class="text-2xl font-bold text-gray-800">{{ statistics?.total_used_coupons || 0 }}</h2>
          <p class="text-xs text-gray-400 mt-1">Coupons redeemed by learners</p>
        </div>
        <div class="bg-white p-4 rounded shadow">
          <p class="text-gray-500 text-sm font-medium mb-2">Total Remaining Coupons</p>
          <h2 class="text-2xl font-bold text-gray-800">{{ statistics?.total_remaining_learners || 0 }}</h2>
          <p class="text-xs text-gray-400 mt-1">Available coupons for redemption</p>
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs flex border-b mb-4">
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-orange-500 text-orange-500': currentTab === 'institutions' }"
        @click="currentTab = 'institutions'">
        Institutions
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-orange-500 text-orange-500': currentTab === 'total-income' || currentTab === 'institution-income' }"
        @click="currentTab = 'total-income'">
        Income
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-orange-500 text-orange-500': currentTab === 'courses-coupon' }"
        @click="currentTab = 'courses-coupon'">
        Courses Coupon
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-orange-500 text-orange-500': currentTab === 'locums' }" @click="currentTab = 'locums'">
        Locums
      </button>
    </div>
    <component :is="currentTabComponent" ref="tabComponentRef" :search-query="searchQuery"
      @update-statistics="handleStatisticsUpdate"></component>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue'; // Add Composition API imports
import { useStore } from 'vuex'; // Import Vuex store
import { useRouter } from 'vue-router'; // Import Vue Router
import InstitutionsTab from "@/components/tabs/InstitutionsTab.vue";
import IncomeTab from "@/components/tabs/IncomeTab.vue";
import CoursesCouponTab from "@/components/tabs/CoursesCouponTab.vue";
import LocumsTab from "@/components/tabs/LocumsTab.vue";
import RegisterInstitutionModal from "@/components/forms/RegisterInstitutionModal.vue";
import { InstitutionsAPI } from '@/services';
import AWS from 'aws-sdk';
import { useToast } from 'vue-toastification';

export default {
  name: 'ElearningDashboardPage',
  components: {
    InstitutionsTab,
    IncomeTab,
    CoursesCouponTab,
    LocumsTab,
    RegisterInstitutionModal,
  },
  props: {
    tab: {
      type: String,
      default: 'institutions',
    },
  },
  emits: ['login-required'], // Declare the login-required event
  setup(props, { emit }) {
    // Get tab from route props if available, default to 'institutions'
    const routeTab = props.tab || 'institutions'; // Accept emit and refs from setup context
    const toast = useToast();
    const store = useStore();
    const router = useRouter();

    // Reactive data
    const currentTab = ref(routeTab);
    const tabComponentRef = ref(null);
    const showInstitutionModal = ref(false);
    const dropdownOpen = ref(false);
    const currentStep = ref("institution-type");
    const searchQuery = ref("");
    const phoneNumberDigits = ref("");
    const logoPreview = ref(null);
    const documentError = ref(null);
    const logoError = ref(null);
    const isLoading = ref(false);
    const showSuccessMessage = ref(false);
    const statistics = ref({
      total_institutions: 0,
      total_active_institutions: 0,
      total_suspended_institutions: 0,
    });
    const activeInstitutions = ref(354);
    const totalRevenue = ref(0.0);
    const revenueChange = ref(-1.2);
    const totalDisbursed = ref(0);
    const disbursedChange = ref(11);
    const revenueRetained = ref(0.0);
    const retainedChange = ref(5.2);
    const institutionName = ref('Ravenue Dashboard');

    onMounted(() => {
      // Check if user is authenticated for eLearning system
      if (!store.getters.isAuthenticated('eLearning')) {
        emit('login-required'); // Emit login-required event
      }
    });

    // Watch currentTab changes and update URL + localStorage
    watch(currentTab, (newTab) => {
      // Save to localStorage for persistence across sessions
      localStorage.setItem('elearning_current_tab', newTab);

      // Update the URL without page refresh
      if (newTab && newTab !== 'institutions') {
        router.replace(`/e-learning/dashboard/${newTab}`);
      } else if (newTab === 'institutions') {
        router.replace('/e-learning');
      }
    });

    // Methods
    const logout = async () => {
      // Show logout toast message using the toast from setup
      toast(
        'You have been logged out successfully. Thank you for using E-Learning!',
        {
          type: 'info',
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: true,
          rtl: false
        }
      );

      // Clear auth state first
      store.dispatch('logout');

      // Use window.location.href as fallback for more reliable navigation
      try {
        await router.push('/login');
      } catch (error) {
        console.warn('Router navigation failed, using window.location:', error);
        window.location.href = '/login';
      }
    };

    const formatCurrency = (value) => {
      return `KES ${value.toLocaleString()}`;
    };

    const handleStatisticsUpdate = (stats, individual_institution) => {
      statistics.value = { ...statistics.value, ...stats };
      if (stats) {
        if (individual_institution === 'individual') {
          institutionName.value = statistics.value?.institution?.name;
          currentTab.value = "institution-income";
        } else if (individual_institution === 'total') {
          institutionName.value = 'Ravenue Dashboard';
          currentTab.value = "total-income";
        }
      } else {
        institutionName.value = 'Ravenue Dashboard';
        currentTab.value = "institutions";
      }
    };

    const redirectProfilePage = () => {
      router.push('/profile');
    };

    const openNewInstitutionModalForm = () => {
      showInstitutionModal.value = true;
      currentStep.value = "institution-type";
    };

    const closeInstitutionModal = () => {
      showInstitutionModal.value = false;
    };

    const handleInstitutionCreated = () => {
      showInstitutionModal.value = false;
      tabComponentRef.value.fetchInstitutions();
    };

    const onImageError = (event) => {
      event.target.src = '/path/to/fallback/image.png'; // Replace with your fallback image path
    };

    const currentTabComponent = computed(() => {
      switch (currentTab.value) {
        case "institutions":
          return "InstitutionsTab";
        case "total-income":
          return "IncomeTab";
        case "institution-income":
          return "IncomeTab";
        case "courses-coupon":
          return "CoursesCouponTab";
        case "locums":
          return "LocumsTab";
        default:
          return "InstitutionsTab";
      }
    });

    const openCouponModal = () => {
      console.log('openCouponModal called, tabComponentRef:', tabComponentRef.value);
      console.log('currentTab:', currentTab.value);
      if (tabComponentRef.value && typeof tabComponentRef.value.openCouponModal === 'function') {
        tabComponentRef.value.openCouponModal();
      } else {
        console.warn('Cannot open coupon modal - ref not available or method missing');
      }
    };

    return {
      // Data
      currentTab,
      showInstitutionModal,
      dropdownOpen,
      currentStep,
      searchQuery,
      phoneNumberDigits,
      logoPreview,
      documentError,
      logoError,
      isLoading,
      showSuccessMessage,
      statistics,
      activeInstitutions,
      totalRevenue,
      revenueChange,
      totalDisbursed,
      disbursedChange,
      revenueRetained,
      retainedChange,
      institutionName,
      // Methods
      logout,
      formatCurrency,
      handleStatisticsUpdate,
      redirectProfilePage,
      openNewInstitutionModalForm,
      closeInstitutionModal,
      handleInstitutionCreated,
      onImageError,
      currentTabComponent,
      tabComponentRef,
      openCouponModal,
    };
  },
};
</script>